import DOMPurify from "dompurify";
import { SAFE_URI_REGEXP } from "./safe_href";

// input is only reachable as a task list checkbox, since raw HTML is escaped before this runs.
const ALLOWED_TAGS = [
  "a", "b", "blockquote", "br", "code", "del", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
  "hr", "i", "input", "li", "ol", "p", "pre", "s", "span", "strong", "sub", "sup", "table", "tbody",
  "td", "tfoot", "th", "thead", "tr", "ul",
];

// target isn't a DOMPurify default, and ALLOW_DATA_ATTR is off, so both are listed by name.
const ALLOWED_ATTR = [
  "align", "checked", "class", "colspan", "data-massimo-icon", "data-turbo", "disabled", "href",
  "rel", "rowspan", "start", "target", "title", "type",
];

export default function sanitizeMessageHtml(html) {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: SAFE_URI_REGEXP,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    FORBID_ATTR: ["style"],
  });
}
